import { persianNumber } from "../shared/persian-number";

export const persianLanguage = {
    word: {
        account: {
            ACCOUNT: 'حساب',
            BALANCE: 'مانده',
            INVENTORY: 'موجودی',
        },
        attachment: {
            ATTACHMENT: 'پیوست',
            ATTACHMENTS: 'پیوست ها',
            FILE_NAME: 'اسم پیوست',
            FILE_LINK: 'لینک پیوست',
        },
        auth: {
            OTP: 'کد تایید',
        },
        asset: {
            ASSET: 'دارایی',
        },
        contract: {
            CONTRACT: 'قرارداد',
            CONTRACTS: 'قراردادها',
        },
        credit:{
            CREDIT: 'اعتبار',
        },
        wallet:{
            WALLET: 'وجه نقد',
            CASH: 'نقد',
            AS_CASH: 'نقدی',
        },
        currency: {
            RIAL: 'ریال',
            DOLLAR: 'دلار',
            MONEY: 'پول',
            TOOMAN: 'تومان',
        },
        general: {
            ACTIVE: 'فعال',
            DEACTIVE: 'غیر فعال',
            ADD: 'افزودن',
            ACCESS: 'دسترسی',
            AGAIN: 'دوباره',
            ALL: 'همه',
            AMOUNT: 'مقدار',
            AMOUNT_TYPE: 'مقداری',
            AND: 'و',
            APPROVE: 'تایید',
            APPROVED: 'تایید شده',
            APPROVED_ONES: 'تایید شده‌ها',
            AUTOMATIC: 'خودکار',
            BUBBLE: "حباب",
            BUY_DELIVERY: 'پرداخت',
            CANCEL: 'انصراف',
            CAPTCHA: 'کپچا',
            CATEGORY: 'دسته بندی',
            CHANGE: 'تغییر',
            CHANGES: 'تغییرات',
            CLOSE: 'بستن',
            CODE: 'کد',
            COMMISSION: 'کارمزد',
            CONNECTION: 'اتصال',
            CONNECTIONS: 'اتصال ها',
            COPY: 'کپی',
            CREDITOR: 'بستانکار',
            CREDITOR_ABBREVIATION: 'بس',
            CUSTOMER: 'مشتری',
            DATA: 'داده',
            DATE: 'تاریخ',
            DEBTOR: 'بدهکار',
            DEBTOR_ABBREVIATION: 'بد',
            DECREASE: 'کاهش',
            DELETE: 'حذف',
            DELIVERY: 'تحویل',
            DESCRIPTION: 'توضیح',
            DESCRIPTIONS: 'توضیحات',
            DETAILS: 'جزییات',
            DIGIT: 'رقم',
            DOWNLOAD: 'دانلود',
            EDIT: 'ویرایش',
            ENTER: 'ورود',
            EXCEL: 'اکسل',
            EXPLANATION: 'شرح',
            FACTOR: 'فاکتور',
            FROM: 'از',
            GENERAL: 'عمومی',
            GEO_AREA: 'منطقه جغرافیایی',
            GEO_AREAS: 'مناطق جغرافیایی',
            GROUP: 'گروه',
            HISTORY: 'تاریخچه',
            HOME: 'خانه',
            ID: 'شناسه',
            INDEX: 'ردیف',
            INCREASE: 'افزایش',
            INFORMATION: 'اطلاعات',
            IN_CALL: 'تلفنی',
            IN_PERSON: 'حضوری',
            LAST:  'آخرین',
            LEVEL: 'سطح',
            LOGO: 'لوگو',
            MINIMUM_VALUE: 'کمترین مقدار',
            MAXIMUM_VALUE: 'بیشترین مقدار',
            MANAGER: 'مدیر',
            MESSAGE: 'پیام',
            MESSAGES: 'پیام ها',
            SHOW: 'نمایش',
            STEP: 'گام',
            STEP_VALUE: 'مقدار تغییر',
            NAME: 'نام',
            NEW: 'جدید',
            OFFLINE: 'آفلاین',
            ONLINE: 'آنلاین',
            OPERATION: 'عملیات',
            OR: 'یا',
            ORDER: 'سفارش',
            PERCENT: 'درصد',
            PERCENT_TYPE: 'درصدی',
            PREREQUISITE: 'پیش نیاز',
            PICTURE: 'عکس',
            PDF: 'پی دی اف',
            PREVIEW: 'پیش نمایش',
            QUANTITY: 'کالا',
            RECEIVE: 'دریافت',
            RECORD: 'رکورد',
            REGISTER: 'ثبت',
            REJECT: 'رد',
            RESET: 'بازنشانی',
            REQUEST: 'درخواست',
            REFRESH: 'رفرش',
            REMAINING: 'باقیمانده',
            REQUIRED: 'لازم است',
            REPRESENTATIVE: 'نماینده',
            REPRESENTATIVES: 'نمایندگان',
            RESULT: 'نتیجه',
            RETRY: 'تلاش دوباره',
            RETURN: 'بازگشت',
            ROUNDING: 'گرد کردن',
            SELECT: 'انتخاب',
            SALE: 'فروش',
            SEARCH: 'جستجو',
            SEND: 'ارسال',
            SETTINGS: 'تنظیمات',
            SITE: 'سایت',
            SOURCE: 'منبع',
            SOURCES: 'منابع',
            STATE: 'استان',
            STATUS: 'وضعیت',
            SUBMIT: 'ثبت',
            SUGGESTED: 'پیشنهادی',
            SUMMATION: 'مجموع',
            SYSTEM_CODE: 'کد سیستم',
            SYMBOL: 'نماد',
            TEST: 'تست',
            TOKEN: 'توکن',
            TRACKING_CODE: 'کد رهگیری',
            TRACKING_CODES: 'کدهای رهگیری',
            TRADABLE: 'قابل معامله',
            TRANSMITTER: 'انتفال دهنده',
            UNIT: 'واحد',
            UPDATE: 'بروزرسانی',
            TITLE: 'عنوان',
            TO: 'به',
            TOTAL: 'کل',
            TYPE: 'نوع',
            TOTAL_PRICE: 'قیمت کل',
            UNIT_PRICE: 'فی',
            UNTIL: 'تا',
            VALUE: 'مقدار',
            WEEKDAY: 'روز هفته',
            WEIGHT: 'وزن',
            WITH: 'با',
            YESTERDAY: 'دیروز',
            YOU: 'شما',
        },
        geo: {
            ADDRESS: 'آدرس',
            CITY: 'شهر',
            PROVINCE: 'استان',
            GEO_AREA: 'منطقه جغرافیایی',
            GEO_AREAS: 'مناطق جغرافیایی',
        },
        gold: {
            COIN: 'سکه',
            GOLD: 'طلا',
            IMAMI_COIN: 'سکه امامی',
            HALF_COIN: 'نیم سکه',
            QUARTER_COIN: 'ربع سکه',
            GRAM: 'گرم',
            GRAM_TYPE: 'گرمی',
            GRAM_COIN: 'سکه گرمی',
            GRAM_18: 'گرم 18',
            GRAM_20: 'گرم 20',
            GRAM_21: 'گرم 21',
            SUT: 'سوت',
            OUNCE: 'انس',
            MESQAL: 'مظنه',
            MELTED: 'آبشده',
            TYPE: 'نوع',
        },
        management: {
            MANAGEMENT: 'مدیریت',
        },
        notification: {
            NOTIFICATION: 'نوتیفیکیشن',
            NOTIFICATIONS: 'نوتیفیکیشن ها',
            UNREAD_NOTIFICATIONS: 'نوتیفیکیشن های خوانده نشده',
            READ_NOTIFICATIONS: 'نوتیفیکیشن های خوانده شده',
            NOT_REAEDED: 'خوانده نشده',
            REAEDED: 'خوانده شده',
            SELECTED_NOTIFICATION_HAS_BEEN_READ: 'نوتیفیکیشن انتخاب شده خوانده شد',
        },
        number: {
            FIRST: 'اول',
            NUMBER: 'عدد',
            NUMERIC: 'عددی',
            SECOND: 'دوم',
        },
        photo: {
            PHOTO: 'تصویر',
        },
        price: {
            PRICE: 'قیمت',
            PRICE2: 'مبلغ',
            PRICE3: 'فی',
            PRICE_TYPE: 'نوع قیمت',
            BUY: 'خرید',
            SELL: 'فروش',
        },
        quantityDefinition: {
            MAIN_QUANTITY: 'کالای اصلی',
            QUANTITY: 'کالا',
            QUANTITY2: 'کالای',
            QUANTITIES: 'کالا ها',
            PARENT_QUANTITY: 'کالای والد',
            PARENT_QUANTITIES: 'کالای والد',
            QUANTITIES2: 'کالا های',
            UNIT: 'واحد',
            TITLE: 'کالا',
            ROUNDING_VALUE: 'مقدار گرد کردن',
        },
        receipt: {
            RECEIPT:'فیش',
            RECEIPTS:'فیش ها',
        },
        report: {
            REPORT: 'گزارش',
            REPORTS: 'گزارش ها',
        },
        server: {
            SERVER: 'سرور',
        },
        time: {
            DAY: 'روز',
            TODAY: 'امروز',
            TIME: 'زمان',
            HOUR: 'ساعت',
            MINUTE: 'دقیقه',
            SECOND: 'ثانیه',
        },
        transaction: {
            APPROVED_OR_DISAPPROVED: 'تایید/رد',
            ORDER_TYPE: 'نوع سفارش',            
            TRANSACTION: 'معامله',
            TRANSACTIONS: 'معاملات',
            TRANSACTION_DATE: 'تاریخ معامله',
            TRANSATION_TIME:  'زمان معامله',
            TRANSACTION_TYPE: 'نوع معامله',
            TRANSACTION_AMOUNT: 'مقدار معامله',
            IS_APPROVED: 'وضعیت تایید',
            CLOSED: 'بسته شده',
            LOCKED: 'قفل شده',
            FINAL_APPROVING: 'وضعیت تایید نهایی',

            IS_APPROVED_CHANGED_BY: 'شخص بررسی کننده',
            DURATION_TIME: 'مهلت تعیین وضعیت معامله',
            DETERMINE_TRANSACTION_APPROVATION: 'تعیین وضعیت معامله',
            DETERMINE_TRANSACTION_FINAL_APPROVATION: 'تعیین وضعیت  نهایی معامله',
            EXPIRATION: 'زمان انقضای خودکار',
            REMAINING_DEADLINE_TIME: 'مهلت باقیمانده از انقضا',
            TRANSACTIONS_HISTORY: 'تاریخچه معاملات',
            TRANSACTIONS_AWAITING: 'معاملات در حال بررسی',
            
        },
        user: {
            ADDRESS: 'آدرس',
            EMAIL: 'ایمیل',
            FIRST_NAME: 'نام',
            FIRST_MOBILE_NUMBER: 'شماره همراه 1',
            FIRST_PICTURE: 'تصویر اول',
            FULL_NAME: ' نام و  نام خانوادگی',
            LAST_NAME: 'نام خانوادگی',
            LOGIN: 'ورود',
            LOGOUT: 'خروج',
            NATIONAL_CODE: 'کد ملی',
            PASSWORD: 'رمز عبور',
            PHONE_NUMBER: 'شماره تلفن',
            MOBILE_NUMBER: 'شماره موبایل',
            POSTAL_CODE: 'کد پستی',
            PROFILE: 'پروفایل',
            PROFILES: 'پروفایل ها',
            RELEASE_DATE: 'تاریخ انتشار',
            RECEIVE_SMS: 'دریافت پیامک',
            SECOND_MOBILE_NUMBER: 'شماره همراه 2',
            SECOND_PICTURE: 'تصویر دوم',
            SHOP: 'مغازه',
            USER: 'کاربر',
            USERS: 'کاربران',
            USERNAME: 'نام کاربری',
            USER_MENU: 'منوی کاربر',
            USER_TYPE: 'نوع کاربر',

        },
    },
    phrase: {
        account: {
            ACCOUNT_BALANCE: 'مانده حساب',
        },
        accounting: {

        },
        asset: {
            ASSET_VALUE_AFTER_CHANGE: 'مقدار بعد از تغییر',
            PREVIOUS_ASSET_VALUE: 'مقدار پیشین',
        },
        attachment: {
            CHOOSE_ATTAVHMENT: 'پیوست را انتخاب کنید.',
            NEW_ATTACHMENT: 'پیوست جدید',
            
        },
        contract: {
            ADD_CONTRACT: 'قرارداد جدید',
            DELETE_CONTRACT: 'حذف قرارداد',
            EDIT_CONTRACT: 'ویرایش قرارداد',
            CHANGE_CONTRACT_STATUS: 'تغییر وضعیت قرارداد',
            CONTRACT_NUMBER: 'شماره  قرارداد',
            CONTRACT_STATUS: 'وضعیت  قرارداد',
            SHOW_CONTRACT_ATTACHMENTS: 'نمایش پیوست های قرارداد',
        },
        credit: {
            CASH_CREDIT: 'اعتبار نقدی',
            CREDIT: 'اعتبار',
            USER_CREDIT: 'اعتبار کاربر',
            NO_CREDIT: 'عدم اعتبار',
        },
        date: {
            LAST_THREE_DAYS: 'سه روز گذشته',
            WRONG_DATE_FILTER: 'فیلتر تاریخ اشتباه است',
            START_DATE_THRESHOLD_HITTED: `گزارش ها حداکثر تا ${persianNumber(30)} روز گذشته در دسترس است`,
        },
        error: {
            ERROR_400: 'خطایی رخ داده است.',
            ERROR_401: 'نام کاربری یا رمز عبور را اشتباه وارد کرده اید.',
            ERROR_401_2: 'دسترسی لازم را ندارید',
            ERROR_403: 'دسترسی لازم را ندارید.',
            ERROR_404: 'درخواست مورد نظر یافت نشد',
            ERROR_405: 'درخواست مورد نظر شما ممکن نیست',
            ERROR_406: 'پاسخ  دریافتی صحیح نیست',
            ERROR_409: 'درخواست  شما با سیستم مغایرت دارد',
            ERROR_429: 'تعداد درخواست های ارسالی شما از حد مجاز بیشتر است.',
            ERROR_500: 'خطای داخلی رخ داده است.',
            ERROR_ENCOUNTERED: 'با خطا مواجه شد',
            ERROR_POST_DATA: 'ارسال اطلاعات با خطا مواجه شد.',
            ERROR_EDIT_DATA: 'ویرایش با خطا مواجه شد.',
            ERROR_DELETE_RECORD: 'حذف رکورد با خطا مواجه شد.',
            ERROR_PAGE_NOT_FOUND: 'صفحه مورد نظر یافت نشد.',
            ERROR_MOBILE_NUMBER_WRONG_FORMAT: 'فرمت شماره وارد شده اشتباه است',
            ERROR_NOT_POSSIBLE_DELETION: 'امکان حذف وجود ندارد',
        },
        finance: {
            FINANCIAL_REPORT: 'گزارش مالی',
        },
        general: {
            ACCEPTED_TERMS_AND_CONDITIONS: 'قوانین و مقررات پذیرفته شده',
            APPLY_TO_ALL: 'اعمال برای همه',
            ADD_QUANTITY_DEFINITION: 'افزودن کمیت',
            CHANGE_MEMBERSHIP: 'تغییر عضویت',
            CREATED_BY: 'ایجاد شده توسط',
            CREATED_ON: 'تاریخ ایجاد',
            CURRENT_PICTURE: 'تصویر فعلی',
            DELETED: 'حذف شد',
            DESELECT_SELECTED_ONES: ' لغو انتخاب (ها)',
            DELETE_SELECTED_RECORDS: 'حذف رکوردهای انتخاب شده',
            DELETE_RECORD: 'حذف رکورد',
            DESIRED_RECORD: 'رکورد مورد نظر',
            DESIGNED_BY_GOHAR: 'طراحی و اجرا: تابان گوهر',
            EDIT_QUANTITY_DEFINITION: 'ویرایش کمیت',
            ENGLISH_TITLE: 'عنوان انگلیسی',
            EXPIRED_ON: 'زمان باطل شدن',
            FARVARDIN_GOLD: 'طلای فروردین',
            YAZD_FARVARDIN_GOLD: 'طلای‌‌فروردین',
            FROM_THE_SYSTEM: 'از سامانه',
            GET_OTP_CODE: 'دریافت کد تایید',
            HAMKAR_TALA: 'همکارطلا',
            I_ACCEPT_TERMS_AND_CONDITIONS: 'قوانین و مقررات را مطالعه کرده و می پذیرم',
            INCREASE_OR_DECREASE: 'افزایش(کاهش)',
            IS_LOADING: 'در حال بارگذاری',
            IS_MEMBER: 'عضو هست',
            MAKE_COPY: 'کپی کردن',
            MAKE_INACTIVE: 'غیرفعال کردن',
            NEW: "جدید",
            NEXT_PAGE: 'صفحه بعد',
            PREVIOUS_PAGE: 'صفحه قبل',
            PLACEHOLDER_FOR_NUMBER: 'مقدار را وارد کنید.',
            PDF_ORIENTATION_SELECTION: 'انتخاب جهت خروجی PDF',
            PRICE_MARKUP_GROUPS: 'گروه های تغییر قیمت',
            QUANTITY_TYPE: 'نوع کمیت',
            RECORD_DATA: 'ثبت اطلاعات',
            REFRESH_DATAGRID: 'بروزرسانی',
            REMOVE_QUANTITY_DEFINITION: 'حذف کمیت',
            RETRY_AGAIN: 'دوباره تلاش کنید',
            ROBOT_DETECTED: 'ربات تشخیص داده شدید',
            SHOWING_ORDER: 'ترتیب نمایش',
            SEND_AGAIN: 'ارسال مجدد',
            TERMS_AND_CONDITIONS: 'قوانین و مقررات',
            TO_THE_SYSTEM: 'به سامانه',
        },
        geoArea: {
            ADD_GEO_AREA: 'افزودن منطقه جغرافیایی',
            EDIT_GEO_AREA: 'ویرایش منطقه جغرافیایی',
            DELETE_GEO_AREA: 'حذف منطقه(مناطق) جغرافیایی',
        },
        gold: {
            GOLD_PRICE_REGISTER: ' ثبت قیمت طلا',
            GOLD_TRADING_PLATFORM: ' سامانه معاملات طلا',
            SUGGESTED_MESQAL: 'مظنه پیشنهادی',
            PRICE_HISTORY: 'تاریخچه قیمت ها',
            CHANGE_MESQAL: 'تغییر مظنه',
        },
        photo: {
            SELECT_PHOTO: 'تصویر را انتخاب کنید.',
            SELECT_FIRST_PHOTO: 'تصویر اول را انتخاب کنید.',
            SELECT_SECOND_PHOTO: 'تصویر دوم را انتخاب کنید.',
        },
        profile: {
            USER_PROFILES: ' پروفایل کاربران',
            PROFILE_DETAIL: 'جزییات پروفایل',
            PROFILE_EDIT: 'ویرایش پروفایل',
            NEW_PROFILE: 'پروفایل جدید',
        },
        purchase_power: {
            PURCHASE_POWER: 'قدرت خرید'
        },
        quantity: {
            ADD_QUANTITY_DEFINITION: 'افزودن کالا',
            EDIT_QUANTITY_DEFINITION: 'ویرایش کالا',
            CONVERSION_FACTOR: 'ضریب تبدیل',
            SHOW_PRICE_PER_GRAM: 'نمایش قیمت فقط بر حسب گرم',
            CONVERSION_FACTOR_EXAMPLE: 'برای تبدیل مثفال به گرم',
        },
        receipt: {
            DOWNLOAD_RECEIPT: 'دانلود فیش',
            NEW_RECEIPT: 'فیش جدید',
            RECEIPT_DETAIL: 'جزییات فیش',
            RECEIPT_PICTURE: 'تصویر فیش',
            RECEIPT_LIST: 'لیست فیش ها',
            TRANSACTIONS_NUMBER: 'شماره معاملات',
            CHOOSE_RELATED_TRANSACTIONS: 'انتخاب معاملات مرتبط',
            DETERMINE_RECEIPT_APPROVATION: 'تعیین وضعیت فیش',
            RECEIPT_RELATED_TRANSACTIONS_CODES: 'کدهای معاملات مرتبط',
        },
        refresh: {
            SUCCESSFUL_REFRESH: 'به روز رسانی با موفقیت انجام شد.',
            FAIL_REFRESH: 'به روز رسانی با با خطا مواجه شد. دوباره تلاش کنید..',
        },
        required: {
            AMOUNT_REQUIRED: 'مقدار را وارد کنید.',
            CITY_NAME_REQUIRED: 'نام شهر را وارد کنید',
            CODE_REQUIRED: 'کد را وارد کنید.',
            CHOOSE_STATUS: 'وضعیت را انتخاب کنید',
            CONVERSION_FACTOR_REQUIRED: 'ضریب تبدیل را وارد کنید',
            DESCRIPTION_REQUIRED: 'توضیحات را وارد کنید.',
            DIGIT_PATTERN_MESSAGE: 'اعداد اعشار  مجاز نیست',
            NATIONAL_CODE_MUST_BE_TEN_DIGITS: 'کد ملی باید ده رقمی باشد.',
            EMAIL_REQUIRED: 'ایمیل را وارد کنید',
            ENGLISH_TITLE_REQUIRED: 'عنوان انگلیسی را وارد کنید.',
            ENTER_OTP_CODE: 'کد تایید را وارد کنید',
            GOLD_TYPE_REQUIRED: 'نوع  طلا را انتخاب کنید',
            IS_REQUIRED: 'لازم است',
            MAXIMUM_2_DECIMAL_PATTERN_MESSAGE: 'حداکثر تا دو رقم اعشار مجاز است',
            MAXIMUM_3_DECIMAL_PATTERN_MESSAGE: 'حداکثر تا سه رقم اعشار مجاز است',
            MESSAGE_REQUIRED: 'پیام را وارد کنید.',
            MOBILE_NUMBER_REQUIRED: 'شماره موبایل را وارد کنید.',
            MOBILE_NUMBER_MUST_BE_ELEVEN_DIGITS: 'شماره همراه باید یازده رقمی باشد',
            MUST_BE_GREATER_THAN_ONE: 'باید بزرگتر از یک باشد',
            MUST_BE_LESS_THAN_FIVE: 'باید کوچکتر از پنج باشد',
            NAME_REQUIRED: 'نام را وارد کنید',
            OTP_REQUIRED: 'کد تایید را وارد کنید.',
            PASSWORD_REQUIRED: 'رمز عبور را وارد کنید.',
            PHONE_NUMBER_MUST_BE_ELEVEN_DIGITS: 'شماره تلفن باید یازده رقمی باشد',
            PRICE_REQUIRED: 'قیمت را وارد کنید',
            POSTAL_CODE_MUST_BE_TEN_DIGITS: 'کد پستی باید ده رقمی باشد.',
            PROVINCE_NAME_REQUIRED: 'نام استان را وارد کنید',
            QUANTITY_REQUIRED: ' کمیت را وارد کنید.',
            QUANTITY_TYPE_REQUIRED: '',
            RIAL_REQUIRED: 'مبلغ را وارد کنید.',
            SUGGESTED_MESQAL_REQUIRED: 'مظنه پیشنهادی را وارد کنید.',
            SUGGESTED_REQUIRED: ' پیشنهادی را وارد کنید.',
            TITLE_REQUIRED: 'عنوان را وارد کنید.',
            TRACKING_CODE_REQUIRED: 'کد رهگیری را وارد کنید.',
            UNIT_REQUIRED: 'واحد را وارد کنید.',
            UNIT_PRICE_REQUIRED: 'فی را وارد کنید.',
            USERNAME_REQUIRED: 'نام  کاربری را وارد کنید.',
            WEIGHT_REQUIRED: 'ورن را وارد کنید.',
        },
        server: {
            CONNECTION_WITH_SERVER: 'ارتباط با سرور',
        },
        success: {
            DONE_WITH_SUCCESS: 'با موفقیت انجام شد.',
            SUCCESS_200: 'درخواست با موفقیت انجام شد.',
            SUCCESS_201: 'با موفقیت ایجاد شد.',
            SUCCESS_204: 'با موفقیت انجام شد.',
            SUCCESS_POST_DATA: 'با موفقیت ثبت شد.',
            SUCCESS_EDIT_OBJECT: 'ویرایش با موفقیت انجام شد.',
            SUCCESS_PROFILE_EDIT: 'پروفایل با  موفقیت ویرایش شد.',
            SUCCESS_PROFILE_CREATION: 'پروفایل با  موفقیت ایجاد شد.',
            SUCCESS_ADD_RECEIPT: 'فیش با  موفقیت ایجاد شد.',
            SUCCESS_ADD_CONTRACT: 'قرارداد با موفقیت ثبت شد.',
            SUCCESS_ADD_ATTACHMENT: 'پیوست با موفقیت ایجاد شد.',
            SUCCESS_PASSWORD_CHANGE: 'رمز عبور با موفقیت تغییر یافت',
        },
        tgn: {
            TGN: '  تابان گوهر',

            TGN_PRICE: 'قیمت های تابان گوهر',
        },
        time: {
            UPDATE_TIME: 'ساعت بروزرسانی',
        },
        transaction: {
            AFTER_CHANGE: 'بعد از تغییر',
            AUTOMATIC_TRANSACTION_EXPIRATION_DURATION: 'زمان باطل شدن خودکار معاملات',
            BEFOR_CHANGE: 'قبل از تغییر',
            FURTHER_DESCRIPTION: 'توضیحات بیشتر',
            TRANSACTION_EXPIRATION_DURATION: 'زمان باطل شدن معاملات',
            RECORD_NEW_TRANSACTION_EXPIRATION_DURATION: 'زمان ابطال  خودکار جدید',
            CHANGE_INITIAL_APPROVEMENT: 'تغییر وضعیت اولیه',
            CHANGE_FINAL_APPROVEMENT: 'تغییر وضعیت نهایی',
        },
        user: {
            SELECT_USER_TYPE: 'انتخاب نوع کاربر',
        },
        wallet: {
            USER_WALLET: 'دارایی نقدی کاربر',
            WALLET: 'دارایی نقدی',
        },
    },
}